import Vue from 'vue'
import Vuex from 'vuex'

import breakpoints from './modules/breakpoints'
import auth from './modules/auth'
import common from './modules/common'
import breadcrumb from './modules/breadcrumb'
import myspace from './modules/myspace'
import modal from './modules/modal'
import page from './modules/page'
import filters from './modules/filters'
import users from './modules/users'
import guests from './modules/guests'
import groups from './modules/groups'
import board from './modules/board'
import spotlight from './modules/spotlight'
import documents from './modules/documents'
import events from './modules/events'
import holidays from './modules/holidays'
import travels from './modules/travels'
import remoteWorking from './modules/remoteWorking'

import header from './modules/header'
import footer from './modules/footer'
import profile from './modules/profile'
import pages from './modules/pages'
import paragraphs from './modules/paragraphs'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    breakpoints,
    breadcrumb,
    auth,
    common,
    myspace,
    modal,
    filters,
    users,
    guests,
    groups,
    board,
    spotlight,
    documents,
    events,
    holidays,
    travels,
    remoteWorking,
    header,
    footer,
    page,
    profile,
    pages,
    paragraphs
  },
  strict: true
})
